const SizesUtils = require('../../../../js/viscom/viscomjs/utils/SizesUtils');
const adapters = require('./adapters');

// import {ClickControllerAdapter} from './ClickController';
// const ClickController = new ClickControllerAdapter();

export class HelperBlockAdapter {
    constructor() {
        this._body = document.body;
        this._canvasContainer = document.querySelector('.canvas-container');
        this._helperBlock = document.querySelector('.helper-block');
        this._helperBlockImage = this._helperBlock.querySelector('.helper-block__image');
        this._screenWidth = SizesUtils.winWidth();
        this._show = false;
        this._disable = false;
        this._helperInterval = {};
    }

    init() {
        setTimeout(() => {
            this.show();
        }, 2000);
    }

    show() {
        this._show = true;
        this._helperBlock.classList.add('show');
        setTimeout(() => {
            this.hide();
            adapters.ClickController().showPreview();
        }, 3200);
    }

    hide() {
        this._show = true;
        this._helperBlock.classList.remove('show');
    }

    disable() {
        this._disable = true;
    }
}
